import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
      overflowX: 'auto',
    },
    table: {
      minWidth: 650,
    },
    vehicleDetail: {
      backgroundColor: '#d7e3f073',
      padding: '35px',
      marginTop: '10px',
      marginBottom: '10px',
      border: '1px solid rgb(224, 224, 224)',
    },
  }),
);
